import { ReactComponent as Li1 } from "../../images/fastTime.svg";
import { ReactComponent as Li2 } from "../../images/comrofrable.svg";
import { ReactComponent as Li3 } from "../../images/center.svg";
import { ReactComponent as Li4 } from "../../images/clientComfortable.svg";
import gsap from "gsap";
import { useLayoutEffect } from "react";

const How = () => {
    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
			let startMarker = "85%";
			gsap.from("#title", {
				scrollTrigger: {
					trigger: ".how",
					start: `150 ${startMarker}`,
				},
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#subTitle", {
				scrollTrigger: {
					trigger: ".how",
					start: `150 ${startMarker}`,
				},
                delay: .2,
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#li1", {
				scrollTrigger: {
					trigger: ".how",
					start: `50% ${startMarker}`,
				},
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#li2", {
				scrollTrigger: {
					trigger: ".how",
					start: `50% ${startMarker}`,
				},
                delay: .1,
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#li3", {
				scrollTrigger: {
					trigger: ".how",
					start: `50% ${startMarker}`,
				},
                delay: .2,
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#li4", {
				scrollTrigger: {
					trigger: ".how",
					start: `75% ${startMarker}`,
				},
                delay: .2,
				y: -50,
				opacity: 0,
				duration: .7,
			})
		});
		return () => ctx.revert();
    }, []);

    return (
        <div className="how">
            <div className="naming" id="title">Преимущества</div>
            <h2 id="subTitle">Почему выбирают наш калькулятор?</h2>
            <ul className="cards">
                <li>
                    <ul className="cardList">
                        <li id="li1">
                            <Li1/>
                            <div className="content">
                                <div className="num">[01]</div>
                                <div className="desc">
                                    <h3>Мгновенные расчеты</h3>
                                    <h4>Автоматизированный подсчет стоимости услуг без сложных формул.</h4>
                                </div>
                            </div>
                        </li>
                        <li id="li2">
                            <Li2/>
                            <div className="content">
                                <div className="num">[02]</div>
                                <div className="desc">
                                    <h3>Гибкие настройки</h3>
                                    <h4>Учитывайте все нюансы: количество операций, вид деятельности, сроки сдачи отчетности.</h4>
                                </div>
                            </div>
                        </li>
                        <li id="li3">
                            <Li3/>
                            <div className="content">
                                <div className="num">[03]</div>
                                <div className="desc">
                                    <h3>Профессиональная точность</h3>
                                    <h4>Алгоритмы, разработанные опытными бухгалтерами, минимизируют ошибки.</h4>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul className="cardList">
                        <li id="li4">
                            <Li4/>
                            <div className="content">
                                <div className="num">[04]</div>
                                <div className="desc">
                                    <h3>Удобноство для клиентов</h3>
                                    <h4>Понятный интерфейс – вы и ваши клиенты сразу видят прозрачную стоимость.</h4>
                                </div>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
}

export default How;